import { CAMPAIGN_TYPES, CAMPAIGN_TYPES_ENUM_VALUE } from '@bingads-webui-campaign/competition-auction-insight-preferences';

export function getCampaignType(serverContext, currentCampaign) {
  if (!serverContext?.Permissions?.IsBAACompetitionBSCAuctionInsightsEnabled) {
    return CAMPAIGN_TYPES.Search;
  } else if (currentCampaign?.CampaignType === CAMPAIGN_TYPES_ENUM_VALUE[CAMPAIGN_TYPES.Shopping]) {
    // CurrentCampaign only has enum value.
    return CAMPAIGN_TYPES.Shopping;
  }
  // for account scope, directly use search
  return CAMPAIGN_TYPES.Search;
}
